export const SET_ONLINE_TEXT = 'SERVERMENU_STATUSTEXTS_SET_ONLINE_TEXT'
export const SET_OFFLINE_TEXT = 'SERVERMENU_STATUSTEXTS_SET_OFFLINE_TEXT'
export const SET_VIP_TEXT = 'SERVERMENU_STATUSTEXTS_SET_VIP_TEXT'
export const SET_UNKNOWN_TEXT = 'SERVERMENU_STATUSTEXTS_SET_UNKNOWN_TEXT'
export const SET_STATUSTEXTS = 'SERVERMENU_STATUSTEXTS_SET_STATUSTEXTS'



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/statusTexts/constants.js